<ng-container>
  <glxy-form-field [bottomSpacing]="bottomSpacing" [required]="minOneRequired">
    @if (label) {
      <glxy-label>{{ label | translate }}</glxy-label>
    }
    @if (buttonPosition === 'top' && showAddAction()) {
      <button mat-button color="primary" (click)="add()" aria-label="Add">
        {{ addText | translate }}
      </button>
    }
  </glxy-form-field>
  @for (control of controlArray.controls; track control; let i = $index; let first = $first; let last = $last) {
    <div class="multi-input-control">
      <glxy-form-field [bottomSpacing]="bottomSpacing">
        <input #input (keydown.enter)="add()" matInput [placeholder]="placeholder" [formControl]="control" />
        @if (!(last && first) && control.status !== 'DISABLED') {
          <button matSuffix mat-icon-button aria-label="Remove" (click)="remove(i)">
            <mat-icon class="close-icon">close</mat-icon>
          </button>
        }
        <div class="hints">
          <div class="text">
            @if (last && tooltip) {
              <glxy-hint align="left" [matTooltip]="tooltip">
                <a (click)="(null)" class="link">
                  {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
                </a>
              </glxy-hint>
            }
            @if (isErrorState(control)) {
              <glxy-error>
                {{ itemErrorOutput(control) }}
              </glxy-error>
            }
            @if (last && isErrorState(controlArray)) {
              <glxy-error>
                {{ errorOutput(controlArray) }}
              </glxy-error>
            }
          </div>
          @if (buttonPosition === 'bottom' && last && showAddAction()) {
            <glxy-hint align="right">
              <button mat-button color="primary" (click)="add()" class="link-button" aria-label="Add">
                {{ addText | translate }}
              </button>
            </glxy-hint>
          }
        </div>
      </glxy-form-field>
      <div class="print">
        <div class="label">{{ label | translate }}:</div>
        <div class="answer">{{ control.value }}</div>
      </div>
    </div>
  }
</ng-container>
